export default function MiniProjector() {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_845_15038)">
                <path
                    d="M39 19.5H41.25C42.4926 19.5 43.5 20.5074 43.5 21.75V33.75C43.5 34.9926 42.4926 36 41.25 36H6.75C5.50736 36 4.5 34.9926 4.5 33.75V21.75C4.5 20.5074 5.50736 19.5 6.75 19.5H24"
                    stroke="#949494"
                    strokeWidth="2.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M15 36H9V39H15V36Z" stroke="#949494" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M39 36H33V39H39V36Z" stroke="#949494" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M31.5 28.5C35.6423 28.5 39 25.1423 39 21C39 16.8577 35.6423 13.5 31.5 13.5C27.3577 13.5 24 16.8577 24 21C24 25.1423 27.3577 28.5 31.5 28.5Z"
                    stroke="#949494"
                    strokeWidth="2.25"
                    strokeMiterlimit="10"
                />
                <path d="M21 12L22.5743 13.5743" stroke="#949494" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M25.5 9L26.4384 11.0201" stroke="#949494" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M31.5 7.5V9.72778" stroke="#949494" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M42.0749 12L40.5 13.5743" stroke="#949494" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M36.9384 9L36 11.0201" stroke="#949494" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_845_15038">
                    <rect width="48" height="48" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
